import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { take } from 'rxjs/operators';

import { Category, CategoryService } from '../../../../../core/lists';
import { StringUtilsService } from '../../../../../core/services/string-utils.service';
import { SharingConfig } from '../../models';
import { SharingConfigKey } from '../../enums';
import { DocumentService } from '../../services';
import { GeneralAutocompleteComponent } from '../../../../partials/layout/general-autocomplete/general-autocomplete.component';

@Component({
  selector: 'kt-sharing-doc-config',
  templateUrl: './sharing-doc-config.component.html',
})
export class SharingDocConfigComponent implements OnInit {
  SharingConfigKey = SharingConfigKey;
  configKeys = Object.values(SharingConfigKey);
  configs: SharingConfig[] = [];
  index = '';
  configId = 0;
  getTeamAutocomplete = this.categoryService.searchFilteredCategories.bind(this.categoryService, {
    all: true,
    inboxActivated: true,
  });
  @ViewChild('key') key: MatSelect;
  @ViewChild('value') value: ElementRef;
  @ViewChild('teamAutocomplete') teamAutocomplete: GeneralAutocompleteComponent;

  constructor(
    public stringUtils: StringUtilsService,
    private dialogRef: MatDialogRef<SharingDocConfigComponent>,
    private categoryService: CategoryService,
    private documentService: DocumentService,
  ) {}

  ngOnInit(): void {
    this.documentService
      .getSharingConfigs()
      .pipe(take(1))
      .subscribe((res) => {
        this.configs = res?.data || [];
      });
  }

  reset(event?: Event): void {
    event?.stopPropagation();

    this.index = '';
    this.configId = 0;
    this.key.value = '';

    setTimeout(() => (this.value.nativeElement.value = ''), 100);
  }

  addConfig(event: Event): void {
    event.stopPropagation();

    const config = {
      id: this.configId,
      key: this.key.value,
      value:
        this.key.value === SharingConfigKey.DEFAULT_TEAM
          ? JSON.stringify(this.teamAutocomplete?.value)
          : this.value.nativeElement.value,
    };

    this.index ? (this.configs[this.index] = config) : this.configs.push(config);

    this.reset();
  }

  updateConfig(event: Event, idx: number, config: SharingConfig): void {
    event.stopPropagation();

    this.index = `${idx}`;
    this.configId = config.id;
    this.key.value = config.key;

    setTimeout(() => {
      if (config.key === SharingConfigKey.DEFAULT_TEAM) {
        this.teamAutocomplete.setValue(config.value ? JSON.parse(config.value) : null);
        this.teamAutocomplete.updateValueAndValidity();
      } else {
        this.value.nativeElement.value = config.value;
      }
    }, 100);
  }

  deleteConfig(event: Event, idx: number): void {
    event.stopPropagation();

    this.configs.splice(idx, 1);
  }

  formatConfig(config: SharingConfig): string {
    return config.value
      ? config.key === SharingConfigKey.DEFAULT_TEAM
        ? JSON.parse(config.value)?.name
        : config.value
      : '';
  }

  formatTeamOption(team: Category): string {
    return team?.name || '';
  }

  closeDialog(event: Event): void {
    event.stopPropagation();

    this.dialogRef.close();
  }

  submit(event: Event): void {
    event.stopPropagation();

    this.documentService
      .updateSharingConfigs(this.configs)
      .pipe(take(1))
      .subscribe((res) => {
        if (!res?.ok) return;

        this.dialogRef.close(true);
      });
  }
}
